/**
 * TreeMap constants doc
 */
/**
 * Triggers when the treemap is on load.
 * @private
 */
export var load = 'load';
/**
 * Triggers after treemap rendered.
 * @private
 */
export var loaded = 'loaded';
/**
 * Trigger before call the print method.
 * @private
 */
export var beforePrint = 'beforePrint';
/**
 * Trigger before each treemap item rendered.
 * @private
 */
export var itemRendering = 'itemRendering';
/**
 * Trigger after click on treemap item.
 * @private
 */
export var drillStart = 'drillStart';
/**
 * Trigger after drill start event completed.
 * @private
 */
export var drillEnd = 'drillEnd';
/**
 * Trigger after select the treemap item.
 * @private
 */
export var itemSelected = 'itemSelected';
/**
 * Trigger after hover on the treemap item.
 * @private
 */
export var itemHighlight = 'itemHighlight';
/**
 * Trigger after mouse hover on the treemap item.
 * @private
 */
export var tooltipRendering = 'tooltipRendering';
/**
 * Trigger after click on the treemap item.
 * @private
 */
export var itemClick = 'itemClick';
/**
 * Trigger after mouse hover on the treemap item.
 * @private
 */
export var itemMove = 'itemMove';
/**
 * Trigger after click on the treemap item.
 * @private
 */
export var click = 'click';
/**
 * Trigger after double click on the treemap item.
 * @private
 */
export var doubleClick = 'doubleClick';
/**
 * Trigger after right click on the treemap item.
 * @private
 */
export var rightClick = 'rightClick';
/**
 * Trigger after mouse hover on the treemap item.
 * @private
 */
export var mouseMove = 'mouseMove';
/**
 * Trigger before each treemap item.
 * @private
 */
export var legendItemRendering = 'legendItemRendering';
/**
 * Trigger before legend items.
 * @private
 */
export var legendRendering = 'legendRendering';
/**
 * Trigger after resize the treemap.
 * @private
 */
export var resize = 'resize';
/**
 * Define the font family in treemap component.
 * @private
 */
export var defaultFont = 'Roboto, Segoe UI, Noto, Sans-serif';
